class CookieConsent {
    public getFunctional ():boolean {
        const cookie = this.getCookie('cookiefirst-consent')
        console.log(cookie)

        return true
    }

    getCookie (name:string) :any {
        const value = `; ${document.cookie}`
        const parts:string[] = value.split(`; ${name}=`)
        if (parts && parts != null && parts.length === 2) {
            // @ts-ignore
          return parts.pop().split(';').shift()
        }
    }
}

export const cookieConsent = new CookieConsent()
